export const subtasks = () => {
  const subtaskButton = document.querySelector(".js-subtask-btn");
  const subtaskModal = document.querySelector(".js-subtask-modal");

  if (subtaskModal) {
    const closeButton = subtaskModal.querySelector(".js-subtask-close");

    function showSubtasks(event) {
      subtaskModal.classList.add("subtask--show");
    }

    function closeSubtasks(event) {
      subtaskModal.classList.remove("subtask--show");
    }

    if (subtaskButton) {
      subtaskButton.addEventListener("click", showSubtasks);
    }

    if (closeButton) {
      closeButton.addEventListener("click", closeSubtasks);
    }
  }
};
